type RestrictionDef = {
  id: number;
  name: string;
  value: number; // bit flag (0, 2, 4, 8, 16...)
  description: string;
};

type RawRow = {
  cnt: number;
  restriction: number; // bitmask sum
};

type DecodedRow = {
  restriction: number;
  cnt: number;
  violations: RestrictionDef[]; // розшифрований список
  violationNames: string[]; // тільки назви
};

type SummaryItem = {
  name: string;
  description: string;
  value: number;
  cnt: number; // скільки таких порушень сумарно
};

export function decodeRestrictions(rows: RawRow[], defs: RestrictionDef[]) {
  // 0 (None) не є флагом, тому окремо
  const none = defs.find((d) => d.value === 0) ?? {
    id: 0,
    name: 'IllegalNone',
    value: 0,
    description: 'None',
  };

  const flags = defs.filter((d) => d.value !== 0).sort((a, b) => a.value - b.value);

  const decodedRows: DecodedRow[] = rows.map((row) => {
    const violations =
      row.restriction === 0
        ? [none]
        : flags.filter((rule) => (row.restriction & rule.value) === rule.value);

    return {
      restriction: row.restriction,
      cnt: row.cnt,
      violations,
      violationNames: violations.map((v) => v.name),
    };
  });

  // агрегуємо: name -> total cnt
  const summaryMap = new Map<string, SummaryItem>();

  for (const row of decodedRows) {
    for (const v of row.violations) {
      const key = v.name;
      const prev = summaryMap.get(key);
      if (prev) {
        prev.cnt += row.cnt;
      } else {
        summaryMap.set(key, {
          name: v.name,
          description: v.description,
          value: v.value,
          cnt: row.cnt,
        });
      }
    }
  }

  const summary = Array.from(summaryMap.values()).sort((a, b) => b.cnt - a.cnt);

  return { decodedRows, summary };
}

export function decodeRestrictionValue(restriction: number, defs: RestrictionDef[]): string[] {
  if (!restriction) {
    const none = defs.find((d) => d.value === 0);
    return none ? [none.description] : [];
  }

  return defs
    .filter((d) => d.value !== 0 && (restriction & d.value) === d.value)
    .map((d) => d.description);
}
